import { render, staticRenderFns } from "./ServiceproviderParameters.vue?vue&type=template&id=0522f702&"
import script from "./ServiceproviderParameters.vue?vue&type=script&lang=js&"
export * from "./ServiceproviderParameters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports